import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { appModulesBySpecificity } from 'configs/appModules'
import {getApps} from 'firebase/app';
import debug from 'utils/debugLog';
import {
	signInSecondary, signOut
} from 'redux/actions/Auth';

export const AppViews = props => {

  const { 
		signInSecondary
	} = props
  // MPENA
  // En esta parte consultamos al listado de apps de Firebase inicializadas.
  // Si hay menos de dos instancias, es que hemos perdido conexión con la DB secundaria
    
  if(getApps().length < 2){
    // Obtener data para conectar con DB secundaria tras refresh
    const primaryDataRaw = localStorage.getItem("PRIMARY_DATA")
    const primaryData = JSON.parse(primaryDataRaw)
    // Manda a loguear con la DB secundaria, con los datos de la DB primaria
    debug.log("Conectando a DB secundaria con datos de la primaria", primaryData)
    signInSecondary(primaryData);  
  }
  
  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Switch>
        <Route path={`${APP_PREFIX_PATH}/home`} component={lazy(() => import(`./home`))} />
        <Route path={`${APP_PREFIX_PATH}/resultados`} component={lazy(() => import(`./resultados`))} />
        <Route path={`${APP_PREFIX_PATH}/reports/essbio`} component={lazy(() => import(`./reports/essbio`))} />
        <Route path={`${APP_PREFIX_PATH}/charts`} component={lazy(() => import(`./charts`))} />
        <Route path={`${APP_PREFIX_PATH}/externalReport`} component={lazy(() => import(`./externalReport`))} />
        <Route path={`${APP_PREFIX_PATH}/universal/users`} component={lazy(() => import(`./universal/users`))} />
        <Route path={`${APP_PREFIX_PATH}/universal/sessions`} component={lazy(() => import(`./universal/sessions`))} />
        <Route path={`${APP_PREFIX_PATH}/universal/bloques`} component={lazy(() => import(`./universal/bloques`))} />
        <Route path={`${APP_PREFIX_PATH}/universal/organigrama`} component={lazy(() => import(`./universal/organigrama`))} />
        <Route path={`${APP_PREFIX_PATH}/universal/videoPlayer`} component={lazy(() => import(`./universal/videoPlayer`))} />
        <Route path={`${APP_PREFIX_PATH}/learning/basicCases`} component={lazy(() => import(`./learning/basicCases`))} />
        <Route path={`${APP_PREFIX_PATH}/learning/questions`} component={lazy(() => import(`./learning/questions`))} />
        <Route path={`${APP_PREFIX_PATH}/learning/boards`} component={lazy(() => import(`./learning/boards`))} />
        <Route path={`${APP_PREFIX_PATH}/learning/boardsDetail`} component={lazy(() => import(`./learning/boardsDetail`))} />
        <Route path={`${APP_PREFIX_PATH}/learning/sequenceSelector`} component={lazy(() => import(`./learning/sequenceSelector`))} />
        {/* Rutas de apps Unity — fuente única en configs/appModules.
            Se mantienen para LTI y enlaces directos; el menú las abre en popup.
            Ordenadas por especificidad: <Switch> devuelve la primera
            coincidencia, así que la ruta más larga debe registrarse antes
            (".../PypAiep/Dosimetro" antes de ".../PypAiep"). */}
        {appModulesBySpecificity.map((m) => (
          <Route key={m.path} path={m.path} component={lazy(m.importer)} />
        ))}
        <Route path={`${APP_PREFIX_PATH}/bug-report`} component={lazy(() => import(`./bug-report`))} />
        
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />
      </Switch>
    </Suspense>
  )
}

const mapStateToProps = ({auth}) => {
	const {loading, message, showMessage, token, redirect} = auth;
  return {loading, message, showMessage, token, redirect}
}

const mapDispatchToProps = {
	signInSecondary
}

// export default React.memo(AppViews);

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AppViews))